import React from 'react';
import { IconFork, IconStar, getIcon } from '../Icons';
import './LibraryRecord.scss';
import { LibraryRecordProps } from '../../entities/Library';
import { TooltipTrigger } from '../TooltipTrigger/TooltipTrigger';

export default function LibraryRecord({
  type,
  title,
  description,
  author,
  maintainer,
  version,
  date,
  link,
  stars,
  forks,
}: LibraryRecordProps): React.ReactElement {
  return (
    <>
      <a className="library-record" href={link}>
        <div className="library-record__content">
          <div className="library-record__type">
            {type[0]} {type[1] && <>{type[1]}</>}
          </div>
          <div className="library-record__title">
            <div>{title}</div>
            {(author === 'Arduino' || maintainer.split(' ')[0] === 'Arduino') && (
              <div className="library-record__label">
                {getIcon('IconArduino')}
                {'Arduino'}
              </div>
            )}
            {stars > 0 && (
              <div className="library-record__repo-datas">
                <IconStar /> {stars} Stars
              </div>
            )}
            {forks > 0 && (
              <div className="library-record__repo-datas library-record__fork">
                <IconFork /> {forks} Forks
              </div>
            )}
            <div className="library-record__version">V{version}</div>
          </div>
          <div className="library-record__description">{description}</div>
        </div>
        <div className="library-record__info">
          <TooltipTrigger
            TriggerElement={
              <span className="library-record__author">
                <span className="library-record__icon">{getIcon('IconAccount')}</span>
                {author}
              </span>
            }
            delay={0}
            tooltipPlacement="top"
            tooltipStrategy="absolute"
            tooltipType="tooltip"
          >
            Author
          </TooltipTrigger>
          <TooltipTrigger
            TriggerElement={
              <span className="library-record__maintainer">
                <span className="library-record__icon">{getIcon('IconMaintainer')}</span>
                {maintainer.split(' ')[0]}
              </span>
            }
            delay={0}
            tooltipPlacement="top"
            tooltipStrategy="absolute"
            tooltipType="tooltip"
          >
            Maintainer
          </TooltipTrigger>
          {date && date !== 'Invalid Date' && (
            <TooltipTrigger
              TriggerElement={
                <span className="library-record__date">
                  <span className="library-record__icon">{getIcon('IconHour')}</span>
                  {date}
                </span>
              }
              delay={0}
              tooltipPlacement="top"
              tooltipStrategy="absolute"
              tooltipType="tooltip"
            >
              Last update
            </TooltipTrigger>
          )}
        </div>
      </a>
      <hr />
    </>
  );
}
